import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import Table from '../../components/Table';
import { Pie } from 'react-chartjs-2';

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';


import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import jsPDF from "jspdf";
import "jspdf-autotable";


import { API_URL, ENDPOINTS } from '../../constants/api';
import { apiKey } from '../../utils/ktcUtils';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function ChartsPage() {
  const { route } = useParams();

  const [rows, setRows] = useState([]);
  const [config, setConfig] = useState({ fields: {}, hiddenColumns: [] });
  const [activeTabs, setActiveTabs] = useState({});
  const [link, setLink] = useState({});
  

  useEffect(() => {
    if (route) loadData(route);
  }, [route]);

  // =========================
  // LOAD DATA
  // =========================
  const loadData = async (endpoint) => {
    try {
      const res = await axios.get(
        `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/${endpoint}`,
        {
          headers: { 'x-api-key': apiKey },
        }
      );

      const data = res.data.report || [];
      setLink(res.data.link);

      const cfg = {
        fields: {},
        hiddenColumns: [],
      };

      const cleanRows = data.map((row) => {
        const newRow = {};

        Object.entries(row).forEach(([key, value]) => {
          const parts = key.split('~');
          const realKey = parts[0];
          const actions = parts.slice(1);

          newRow[realKey] = value;

          // init field config
          if (!cfg.fields[realKey]) {
            cfg.fields[realKey] = {
              tabs: false,
              charts: false,
              cards: false,
              chartType: 'pie',
            };
          }

          actions.forEach((action) => {
            const [type, param] = action.split(':');

            switch (type) {
              case 'tabs':
                cfg.fields[realKey].tabs = true;
                break;

              case 'charts':
                cfg.fields[realKey].charts = true;
                cfg.fields[realKey].chartType = param || 'pie';
                break;

              case 'cards':
                cfg.fields[realKey].cards = true;
                break;

              case 'hide':
                cfg.hiddenColumns.push(realKey);
                break;
            }
          });
        });

        return newRow;
      });

      // remove hidden columns
      const finalRows = cleanRows.map((r) => {
        const copy = { ...r };
        cfg.hiddenColumns.forEach((c) => delete copy[c]);
        return copy;
      });

      setConfig(cfg);
      setRows(finalRows);
    } catch (err) {
      console.log(err);
    }
  };

  // =========================
  // TAB HANDLER
  // =========================
  const setTab = (field, value) => {
    setActiveTabs((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // =========================
  // FILTER ROWS
  // =========================
  let filteredRows = [...rows];

  Object.entries(activeTabs).forEach(([field, value]) => {
    if (value && value !== 'All') {
      filteredRows = filteredRows.filter((r) => r[field] === value);
    }
  });

  // =========================
  // CHART BUILDER
  // =========================
  const buildChart = (field) => {
    const counts = {};

    rows.forEach((r) => {
      const key = r[field] || 'Unknown';
      counts[key] = (counts[key] || 0) + 1;
    });

    return {
      labels: Object.keys(counts),
      datasets: [
        {
          data: Object.values(counts),
          backgroundColor: [
            '#4CAF50',
            '#2196F3',
            '#FF9800',
            '#F44336',
            '#9C27B0',
            '#009688',
            '#795548',
            '#607D8B',
          ],
        },
      ],
    };
  };

  // =========================
  // FIELD GROUPS
  // =========================
  const tabFields = Object.entries(config.fields)
    .filter(([_, v]) => v.tabs)
    .map(([k]) => k);


    

     const [activeField, setActiveField] = useState(tabFields[0]);

const getValues = (field) => {
  return [...new Set(filteredRows.map((row) => row[field]))];
};

  const chartFields = Object.entries(config.fields)
    .filter(([_, v]) => v.charts)
    .map(([k, v]) => ({
      field: k,
      chartType: v.chartType,
    }));

  const cardFields = Object.entries(config.fields)
    .filter(([_, v]) => v.cards)
    .map(([k]) => k);

  // =========================
  // UNIQUE TAB VALUES
  // =========================
  const getTabs = (field) => {
    const values = new Set();

    rows.forEach((r) => {
      if (r[field] !== undefined && r[field] !== null && r[field] !== '') {
        values.add(r[field]);
      }
    });

    return ['All', ...Array.from(values)];
  };

const getValueCount = (field, value) => {
  return rows.filter((row) => row[field] === value).length;
};

const exportExcel = () => {
  const ws = XLSX.utils.json_to_sheet(filteredRows);
  const wb = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(wb, ws, "Data");

  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(data, "table-data.xlsx");
};

const exportCSV = () => {
  const ws = XLSX.utils.json_to_sheet(filteredRows);
  const csv = XLSX.utils.sheet_to_csv(ws);

  const blob = new Blob([csv], {
    type: "text/csv;charset=utf-8;",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "table-data.csv";
  link.click();
};


const exportPDF = () => {
  const doc = new jsPDF();

  const columns = Object.keys(filteredRows[0] || {});
  const rows = filteredRows.map((row) =>
    columns.map((col) => row[col])
  );

  doc.text("Table Data", 14, 10);

  doc.autoTable({
    head: [columns],
    body: rows,
    startY: 20,
  });

  doc.save("table-data.pdf");
};

const printTable = () => {
  window.print();
};
  return (
    <div className="py-3">
<style>{`
@media print {

  body * {
    visibility: hidden !important;
  }

  #print-area,
  #print-area * {
    visibility: visible !important;
  }

  #print-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .print-hide {
    display: none !important;
  }

}
`}</style>
      <h2 className="mb-3">{link?.page_title}</h2>

      {/* =========================
          TABS (UNLIMITED + MULTI FIELD)
      ========================= */}
      {/* {tabFields.map((field) => {
        const tabs = getTabs(field);

        return (
          <div key={field} className="d-flex flex-wrap gap-2 mb-3">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setTab(field, tab)}
                className={`btn btn-sm ${
                  activeTabs[field] === tab
                    ? 'btn-success'
                    : 'btn-outline-secondary'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        );
      })} */}
 <div className="row g-2 mb-3">
  {tabFields.map((field) => (
    <div key={field} className="col-6 col-md-3">
      <button
        onClick={() => setActiveField(field)}
        className={`btn w-100 ${
          activeField === field
            ? "btn-primary"
            : "btn-outline-primary"
        }`}
      >
        {field} <span className="badge bg-dark">
          {getTabs(field).length}
        </span>
        
      </button>
    </div>
  ))}
</div>
 <div className="d-flex flex-wrap gap-2">
  {getTabs(activeField).map((value) => {
    const count = getValueCount(activeField, value);

    return (
      <button
        key={value}
        onClick={() => setTab(activeField, value)}
        className={`btn btn-sm d-flex align-items-center gap-2 ${
          activeTabs[activeField] === value
            ? "btn-primary"
            : "btn-outline-primary"
        }`}
      >
        <span>{value}</span>
        <span className="badge bg-dark">
          {count}
        </span>

      </button>
    );
  })}
</div>
      {/* =========================
          CARDS
      ========================= */}
      <div className="row g-3 mb-3">
        {cardFields.map((field) => {
          const total = filteredRows.reduce(
            (sum, r) => sum + Number(r[field] || 0),
            0
          );

          return (
            <div className="col-md-3" key={field}>
              <div className="card shadow-sm">
                <div className="card-body">
                  <small className="text-muted">{field}</small>
                  <h3>{total.toFixed(2)}</h3>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* =========================
          TABLE + CHARTS
      ========================= */}
      <div className="row g-3">

{/* EXPORT + TABLE */}
<div className="col-lg-9">

<div id="print-area">
  <div className="card shadow-sm">

    <div className="card-header d-flex justify-content-end print-hide">
      <button onClick={printTable}>Print</button>
      <button onClick={exportPDF}>PDF</button>
      <button onClick={exportExcel}>Excel</button>
      <button onClick={exportCSV}>CSV</button>
    </div>

    <div className="card-body table-responsive">
      <Table tbodyData={filteredRows} />
    </div>

  </div>
</div>
</div>
        {/* CHARTS */}
        <div className="col-lg-3 d-flex flex-column gap-3">
          {chartFields.map(({ field }, i) => (
            <div className="card shadow-sm" key={field}>
              <div className="card-body">
                <h6>{field}</h6>
                <Pie data={buildChart(field)} />
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}